import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { useGetLink, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonWrapper } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import parse from "html-react-parser";
import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { css } from "styled-components";

const enum fields {
time="time"
}

interface OwnProps extends WidgetProps {
  fields: {
    [fields.time]: number;
  }
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        headerHeight: state.SURData.headerHeightStore.headerHeight,
        location: getLocation(state),
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface SurAnchorTagStyles {}
export const surAnchorTagstyles: SurAnchorTagStyles = {};

const styles = surAnchorTagstyles;

const SurAnchorTag: React.FC<Props> = ({ headerHeight, location,fields }) => {
    const isFirstLoad = useRef(true);
    useEffect(() => {
        const scrollToElement = () => {
          if (typeof window !== "undefined" && window.location.hash) {
            const elementId = window.location.hash.substring(1);
            const matchedTextId = document.getElementById(elementId);
            if (matchedTextId) {
              window.scrollTo({
                top: matchedTextId.offsetTop - headerHeight!,
                behavior: 'smooth',
              });
            }
          }
        };
        if (isFirstLoad.current) {
            setTimeout(() => {
              scrollToElement();
              isFirstLoad.current = false;
            }, 500); // Adjust the timeout as needed
          } else {
            scrollToElement();
          }
        }, [headerHeight, location.hash]);
      

    return <></>;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(SurAnchorTag),
    definition: {
        group: "Common",
        displayName: "SurAnchorTag",
        fieldDefinitions: [
          {
              fieldType: "Translatable",
              name: fields.time,
              displayName: " SettimeOut time ",
              editorTemplate: "TextField",
              defaultValue: "100",
          },]
    },
};
export default widgetModule;
